module.exports = __webpack_public_path__ + "static/media/jambon goosht.d7987029.png";